import React, { useState } from "react";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import VerticalTable from "../../../Table/VerticalTable";
import LineBtn from "../../../Button/LineBtn";
import LmsModal from "../../Message/LmsModal";
import Flex from "../../../DefaultStyles/Flex";
import SubphoneInputModal from "./SubphoneInputModal/SubphoneInputModal";
import { AxiosRequestConfig } from "axios";
import PartyMailModal from "../../Party/PartyDetail/PartyDetailShareInfo/PartyMailModal";
import NewLinkidMailEditModal from "./NewLinkidMailEditModal/NewLinkidMailEditModal";
import BackAccountEditModal from "./BankEditModal/BackAccountEditModal";
import { copyTextToClipboard } from "../../../../AdminApi/commFunc";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

interface UserDetailDefaultInfoProps {
  data?: {
    uid?: string;
    name?: string;
    nickname?: string;
    phone?: string;
    subphone?: string;
    birthday?: string;
    provider?: string;
    providerId?: string;
    indate?: string;
    escaped?: boolean;
    ipLog?: string;
    old_usermail?: string;
    old_second?: string;
    new_usermail?: string;
    user_mail?: string;
    loginTime?: string;
    loginType?: 0 | 1; // 0: web, 1: app
    parent_uid?: string;
    sub_acc?: string[];
  };
  status?: number;
  fetchData: (params: AxiosRequestConfig) => Promise<void>;
}

export default function UserDetailDefaultInfo({
  data,
  status,
  fetchData,
}: UserDetailDefaultInfoProps) {
  const [newLinkidMailEditModal, setNewLinkidMailEditModal] = useState(false);

  const [subphoneInputModal, setSubphoneInputModal] = useState(false);
  const [lmsSendModal, setLmsSendModal] = useState({
    modal: false,
    isSubPhone: false,
  });
  const [viewData, setViewData] = useState({
    user: "",
  });
  const [mailModal, setMailModal] = useState({
    modal: false,
    email: "",
  });

  const oldLinkidMail = data?.old_usermail;
  const oldSecondMail = data?.old_second;
  const newLinkidMail = data?.new_usermail ?? "-";

  const hasOldLinkidMail = Boolean(oldLinkidMail);
  const hasOldSecondMail = Boolean(oldSecondMail);
  const hasNewLinkidMail = Boolean(newLinkidMail);
  const navigate = useNavigate();

  const defaultInfoHeader = [
    "UID",
    data?.parent_uid === data?.uid ? "서브계정 UID" : "주계정 UID",
    "이름",
    "닉네임",
    "전화번호",
    "보조 연락처",
    "생년월일",
    "로그인 수단",
    "로그인 ID",
    "가입 일시",
    "마지막 활동",
    "상태",
    ...(hasOldLinkidMail ? ["구. 링키드 메일"] : []),
    ...(hasOldSecondMail ? ["구. 세컨드 메일"] : []),
    // ...(hasNewLinkidMail ? ["링키드 메일"] : []),
    "링키드메일",
    "유저 메일",
  ];

  function formatPhoneNumber(phoneNumber: string) {
    // 전화번호가 010으로 시작하고, 총 11자리인 경우에만 처리
    // (필요하다면 조건을 추가하거나 수정할 수 있습니다.)
    if (/^010\d{8}$/.test(phoneNumber)) {
      return phoneNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    } else {
      // 포맷이 맞지 않는 경우 별도 처리
      return phoneNumber;
    }
  }

  const defaultInfoBody = [
    [`${data?.uid}`],
    data?.parent_uid === data?.uid
      ? [
          data?.sub_acc && data?.sub_acc.length > 0 ? (
            <div>
              {data?.sub_acc.map((subUid, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom:
                      index < (data?.sub_acc?.length ?? 0) - 1 ? "px" : "0",
                  }}
                >
                  <Flex gapSize={50} style={{ alignItems: "center" }}>
                    <span
                      style={{
                        textDecorationLine: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(`/users/info/${subUid}`)}
                    >
                      {subUid}
                    </span>
                    {/* <LineBtn
                          btnText="이동"
                          sPadding="0 7px"
                          btnClickEvent={() => navigate(`/users/info/${subUid}`)}
                        /> */}
                  </Flex>
                </div>
              ))}
            </div>
          ) : (
            "-"
          ),
        ]
      : [
          data?.parent_uid === data?.uid ? "-" : (
            <span
              style={{
                textDecorationLine: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/users/info/${data?.parent_uid}`)}
            >
              {data?.parent_uid}
            </span>
          ),
        ],
    [`${data?.name}`],
    [`${data?.nickname}`],
    [
      `${(data?.phone === "" ? "-" : formatPhoneNumber(data?.phone!)) ?? "-"}`,
      <LineBtn
        icon="mail"
        sPadding="0 7px"
        btnClickEvent={() => {
          setLmsSendModal({
            modal: true,
            isSubPhone: false,
          });
          setViewData({
            user: `${data?.uid}_${data?.name}_${data?.nickname}`,
          });
        }}
        disabled={!data?.phone || data?.phone === ""}
      />,
    ],
    [
      `${(data?.subphone === "" ? "-" : data?.subphone) ?? "-"}`,
      <Flex gapSize={10}>
        <LineBtn
          icon="edit"
          sPadding="0 7px"
          btnClickEvent={() => {
            setSubphoneInputModal(true);
            setViewData({
              user: `${data?.uid}_${data?.name}_${data?.nickname}`,
            });
          }}
        />

        <LineBtn
          icon="mail"
          sPadding="0 7px"
          btnClickEvent={() => {
            setLmsSendModal({
              modal: true,
              isSubPhone: true,
            });
            setViewData({
              user: `${data?.uid}_${data?.name}_${data?.nickname}`,
            });
          }}
          disabled={!data?.subphone || data?.subphone === ""}
        />
      </Flex>,
    ],
    [`${data?.birthday ?? "-"}`],
    [`${data?.provider}`],
    [`${data?.providerId}`],
    [`${dayjs(data?.indate)?.format("YYYY-MM-DD HH:mm")}`],
    [
      data?.loginTime || data?.ipLog
        ? `${dayjs(data?.loginTime ?? data?.ipLog)?.format(
            "YYYY-MM-DD HH:mm",
          )}${
            data?.loginTime ? ` (${data?.loginType === 1 ? "앱" : "웹"})` : ""
          }`
        : "-",
    ],
    [`${data?.escaped ? `탈퇴 (${data?.nickname})` : `-`}`],
    ...(hasOldLinkidMail
      ? [
          [
            `${oldLinkidMail ?? "-"}`,
            <LineBtn
              btnText="보기"
              sPadding="0 7px"
              btnClickEvent={() => {
                setMailModal({
                  modal: true,
                  email: oldLinkidMail!,
                });
              }}
              disabled={!oldLinkidMail || oldLinkidMail === ""}
            />,
          ],
        ]
      : []),
    ...(hasOldSecondMail
      ? [
          [
            `${oldSecondMail ?? "-"}`,
            <LineBtn
              btnText="보기"
              sPadding="0 7px"
              btnClickEvent={() => {
                setMailModal({
                  modal: true,
                  email: oldSecondMail!,
                });
              }}
              disabled={!oldSecondMail || oldSecondMail === ""}
            />,
          ],
        ]
      : []),
    [
      `${newLinkidMail ?? "-"}`,
      <Flex gapSize={10}>
        <LineBtn
          icon="edit"
          sPadding="0 7px"
          btnClickEvent={() => {
            setNewLinkidMailEditModal(true);
            setViewData({
              user: `${data?.uid}`,
            });
          }}
        />
        <LineBtn
          btnText="복사"
          sPadding="0 7px"
          disabled={!newLinkidMail || newLinkidMail === ""}
          btnClickEvent={() =>
            copyTextToClipboard(newLinkidMail!, "링키드메일이 복사되었습니다.")
          }
        />

        <LineBtn
          btnText="보기"
          sPadding="0 7px"
          btnClickEvent={() => {
            setMailModal({
              modal: true,
              email: newLinkidMail!,
            });
          }}
          disabled={!newLinkidMail || newLinkidMail === ""}
        />
      </Flex>,
    ],
    [`${data?.user_mail ? data?.user_mail : `-`}`],
  ];

  console.log(defaultInfoBody);

  return (
    <>
      <LineBox boxHeight="100%">
        <>
          <TitleWithLine title="기본 정보" />

          <Blank blankHeight={24} />

          <VerticalTable
            tableHeaderData={defaultInfoHeader}
            tableFlexBodyData={status === 200 ? defaultInfoBody : [""]}
            tableMinWidth={250}
          />
        </>
      </LineBox>

      {/* 보조 연락처 수정 모달 */}
      {subphoneInputModal && (
        <SubphoneInputModal
          closeEvent={() => setSubphoneInputModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url: `user/${data?.uid ?? ""}`,
            })
          }
          viewData={viewData}
        />
      )}

      {/* 링키드 메일 수정 모달 */}
      {newLinkidMailEditModal && (
        <NewLinkidMailEditModal
          closeEvent={() => setNewLinkidMailEditModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url: `user/${data?.uid ?? ""}`,
            })
          }
          uid={+viewData.user}
        />
      )}

      {/* lms 보내기 모달 */}
      {lmsSendModal.modal && (
        <LmsModal
          closeEvent={() =>
            setLmsSendModal({
              ...lmsSendModal,
              modal: false,
            })
          }
          type="input"
          viewData={viewData}
          isSubPhone={lmsSendModal.isSubPhone}
        />
      )}

      {/* 링키드 메일함 */}
      {mailModal.modal && (
        <PartyMailModal
          closeEvent={() =>
            setMailModal({
              modal: false,
              email: "",
            })
          }
          mailId={mailModal?.email}
          type="db"
        />
      )}
    </>
  );
}

const ArrowBtn = styled.span`
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.buttonColor.lineHover};
`;
